jQuery(document).ready(function($) {
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
function setCookie(cname, cvalue, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
   if( getCookie('emailsubmition') == 'submitted'){   
       $('.age-overlay').hide();
     $('.claim-entries').hide();
    
  }else{
     setTimeout(()=>{
       $('.age-overlay').show();
     },60000);
      $('.claim-entries').show();
  }

  
  giveVerification();
  $('.claim-offer').on('click',function(){
    sessionStorage.setItem('varificationStep','claim');
    $('.claim-offer,.no-thanks').hide();
    $('#email-input-container').show();  
  });
  

  
  $('.continue-button').on('click',function(){
    let email = $('#email-input').val();
        let emailError = $('#emailError');
        emailError.text('');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email === '') {
            emailError.text('Email is required.');
        } else if (!emailPattern.test(email)) {
            emailError.text('Invalid email');
        } else {
        const emailData =  $('#email-input').val();
           sessionStorage.setItem('userEmail', emailData);
        
          
            sessionStorage.setItem('varificationStep','email');
            $('#email-input-container,.step1').hide();
            $('#phonenumber-input-container,.step2').show();
        }
    
  })
  
  $('.term-and-policies input').change(function(){
     $('#ShopError').hide();
  })
 $('.shop-button').on('click', function() {
  // if ($('.term-and-policies input:checked').length != 2) {
  //  $('#ShopError').show();
  //   } else {      
    sessionStorage.setItem('varificationStep', 'shop');
    $('.age-overlay').hide();
    setCookie('emailsubmition', 'submitted', 3650);
    $('.claim-entries').hide();

    const email = sessionStorage.getItem('userEmail');
    const phone = sessionStorage.getItem('userPhone');

    const formData = {
        Email: email,
        phone: phone
    };
    $.ajax({
        url: 'https://services.leadconnectorhq.com/hooks/Z84UGe3D8EEfYsfT1lpc/webhook-trigger/63065535-3be8-473f-ac98-ba0dd2929a2c',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(formData),
        success: function(response) {
            console.log('Success:', response.status);
            console.log('Tracking ID:', response.id);
          console.log(response)
        },
        error: function(xhr, status, error) {
            console.error('Error:', xhr.status, error);
        }
    });
  // }
});

  
    $('.close_varify_popup').on('click',function(){
      $('.age-overlay').hide();
      $('.claim-entries').show();
    })
    $('.no-thanks').on('click',function() {
      $('.age-overlay').hide();
      $('.claim-entries').show();   
       sessionStorage.setItem('varificationStep','shop');
    })

  
    $('.wrap-claim-entries p').on('click',function(){
        $('.age-overlay').show();
    })
  $('.close-claim-entries').on('click',function(){
      $('.claim-entries').hide();
    })
  function giveVerification() {
    const data = sessionStorage.getItem('varificationStep');
  //  $('.age-overlay').show();
    if(data=="claim"){
      $('.claim-offer,.no-thanks').hide();
      $('#email-input-container').show();  
    }
    if(data=='phone'){
      $('.claim-offer,.no-thanks,.step2,.step1').hide();
      $('#shop-button,.step3').show();
    } 
    if(data=="email"){
      $('.claim-offer,.no-thanks,.step1').hide();
      $('#phonenumber-input-container,.step2').show();       
    }
    if(data=="shop"){
      $('.age-overlay').hide();
    }
  }
});

$(function($) {
	var telInput = $('#phonenumber-input');
	telInput.intlTelInput({
		utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/8.4.8/js/utils.js',
		initialCountry: 'us',
		onlyCountries: [
  'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ',
  'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT',
  'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR',
  'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER',
  'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL',
  'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID',
  'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI',
  'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV',
  'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS',
  'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR',
  'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY',
  'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL',
  'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK',
  'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE',
  'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'
],
	});

	var validate = function(input) {
    if ($.trim(input.val())) {
        if (input.intlTelInput("isValidNumber")) {
            const phoneData = $('#phonenumber-input').val();
            sessionStorage.setItem('userPhone', phoneData);

            $('#phoneError').text('Valid');
            sessionStorage.setItem('varificationStep', 'phone');
            $('#phonenumber-input-container,.step2').hide();
            $('#shop-button,.step3').show();
        } else {
          $('#ShopError').hide()
            $('#phoneError').text('Invalid Number');
            
        }
    }
};

$('.activate-button').on('click', function() {
    let phoneNumber = $('#phonenumber-input').val();
    let phoneError = $('#phoneError');
    phoneError.text('');
    const phonePattern = /^[0-9]*$/;

    if (phoneNumber === '') {
        phoneError.text('Phone is required.');
    } else {     
        if (telInput.intlTelInput("isValidNumber")) {         
            if ($('.term-and-policies input:checked').length != 3) {
                $('#ShopError').show(); 
                return; 
            } else {
                $('#ShopError').hide();
                validate(telInput);
            }
        } else {
            phoneError.text('Invalid Number');
             $('#ShopError').hide()
        }
    }
});

});



const webHookData = 'https://services.leadconnectorhq.com/hooks/Z84UGe3D8EEfYsfT1lpc/webhook-trigger/63065535-3be8-473f-ac98-ba0dd2929a2c';



 

